module.exports = __webpack_public_path__ + "img/f-04.b0b69119.jpg";